import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// DoNotSellLink — P5 privacy fix #5: CCPA "Do Not Sell My Personal Info" link.
// Footer-mounted; opens an inline modal explaining FYD's no-sale policy and
// linking to the personalization settings page.
export function DoNotSellLink() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-sm text-ink-3 hover:text-vermilion underline-offset-2 hover:underline"
        data-testid="do-not-sell-link"
      >
        {t('personalization.ccpaDoNotSellLinkText')}
      </button>
      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-ink/60"
          role="dialog"
          aria-modal
          aria-label={t('personalization.doNotSellModalTitle')}
          onClick={() => setOpen(false)}
          data-testid="do-not-sell-modal"
        >
          <div
            className="max-w-md w-full bg-paper border border-hairline rounded-md p-8 m-4"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="font-serif text-xl font-medium mb-3">
              {t('personalization.doNotSellModalTitle')}
            </h2>
            <p className="text-sm text-ink-2 leading-relaxed mb-6">
              {t('personalization.doNotSellModalBody')}
            </p>
            <div className="flex justify-end gap-3">
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="text-sm text-ink-2 hover:text-ink"
              >
                {t('common.cancel')}
              </button>
              <a
                href="/account/profile"
                className="btn btn-secondary text-sm"
                onClick={() => setOpen(false)}
              >
                {t('consent.viewSettings')}
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DoNotSellLink;
